export default __webpack_public_path__ + "static/media/1828.9512c9c9.png";